<template>
  <v-dialog :model-value="modelValue" max-width="420" @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="text-h6">{{ $t('common.selectLanguage') }}</v-card-title>
      <v-card-text>
        <v-list density="compact">
          <v-list-item
            v-for="lang in languages"
            :key="lang"
            :active="lang === currentLocale"
            @click="selectLanguage(lang)"
          >
            <v-list-item-title>{{ languageLabel(lang) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="$emit('update:modelValue', false)">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { getLanguageFullName } from '@/helpers/language';

export default {
  name: 'LanguageSwitcherModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const store = useStore();

    const languages = computed(() => store.getters['uiI18n/uiLanguages']);
    const currentLocale = computed(() => store.getters['uiI18n/locale']);

    const languageLabel = (code) => getLanguageFullName(code);

    const selectLanguage = async (lang) => {
      await store.dispatch('uiI18n/setLocale', lang);
      emit('update:modelValue', false);
    };

    return {
      languages,
      currentLocale,
      languageLabel,
      selectLanguage,
    };
  },
};
</script>
